var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCite = function SvgCite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cite_svg__path-1",
    d: "M14.24 9.62c1.76.22 4.86 2.46 4.86 6.26 0 2.68-1.56 3.92-3.38 3.92-2.04 0-3.1-1.58-3.1-3.46 0-2.48 1.86-3.1 3.02-3.2.08-.66-.76-1.82-1.78-2.48zm-7.72 0c1.76.22 4.86 2.46 4.86 6.26 0 2.68-1.56 3.92-3.38 3.92-2.04 0-3.1-1.58-3.1-3.46 0-2.48 1.86-3.1 3.02-3.2.08-.66-.76-1.82-1.78-2.48zM0 1v20c0 1.94 1.06 3 3 3h18c1.94 0 3-1.06 3-3V9c0-1.94-1.06-3-3-3H5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cite_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "cite_svg__icons-badges-variations",
    transform: "translate(-219 -946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cite_svg__icons/cite-copy",
    transform: "translate(219 945)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cite_svg__path-1",
    id: "cite_svg__Shape",
    fill: "#000",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 25)"
  }))))));
};
export default SvgCite;